import { authorizedGet } from 'helpCenter/api'
import { Category } from 'helpCenter/types'

export type GetCategoriesProps = {
  collectionId: string
  onlyPublished?: boolean
}

export type GetCategoriesResponseProps = Category[]

export async function getCategories({
  collectionId,
  onlyPublished = false,
}: GetCategoriesProps): Promise<Category[]> {
  try {
    const response = await authorizedGet({
      endpoint: `collections/${collectionId}/categories`,
    })
    const { items: categories } = await response.json() //items, count, pages, page
    if (onlyPublished) {
      return categories.filter(
        (category: any) => category.publishedArticleCount > 0
      )
    } else return categories
  } catch (e) {
    throw e
  }
}
